// extracted by mini-css-extract-plugin
module.exports = {"prefixWrapper":"antd-pro-ui-select-index-prefixWrapper","prefix":"antd-pro-ui-select-index-prefix"};